// extracted by mini-css-extract-plugin
module.exports = {"market":"index_market__1fraY","market_loading":"index_market_loading__VANXB","wrapper":"index_wrapper__Z4buP"};